import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import { useQuoteItems } from "../../../../../providers/quoteItemsProvider";
import { useQuoteRecap } from "../../../../../providers/quoteRecapProvider";
import { utils } from "../../../../../utils/utils";
import QuoteTotalOfficeSectionTotal from "./QuoteTotalOfficeSectionTotal";

const QuoteTotalOfficeSection = () => {
  const [quoteRecapContext] = useQuoteRecap();
  const [quoteItemsContext] = useQuoteItems();
  const [quoteItemManagementRoles, setQuoteItemManagementRoles] = useState([]);

  useEffect(() => {
    const quoteItemManagementRoles = utils.reduceQuoteItemsOfficeLabors(
      quoteItemsContext.quoteItems
    );
    setQuoteItemManagementRoles(quoteItemManagementRoles);
  }, [quoteItemsContext]);

  return (
    <Table className="col-12 mt-4 px-0 border rounded mb-0">
      <tbody>
        {quoteItemManagementRoles
          .sort((x, y) =>
            x.managementRole.code < y.managementRole.code ? -1 : 1
          )
          .map((quoteItemManagementRole) => {
            const { hours, costByHour, totalCost, saleByHour, totalSale } =
              utils.getQuoteItemManagementRoleRow({
                quoteItemManagementRole,
                margin: quoteRecapContext.markupPercentage,
              });
            return (
              <tr key={quoteItemManagementRole.id}>
                <td className="py-0 text-truncate" width={"35%"}>
                  {`${quoteItemManagementRole.managementRole.code} - ${quoteItemManagementRole.managementRole.name}`}
                </td>
                <td className="py-0" width={"13%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatHour(hours)}
                  </div>
                </td>
                <td className="py-0" width={"13%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(costByHour)}
                  </div>
                </td>
                <td className="py-0" width={"13%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(totalCost)}
                  </div>
                </td>
                <td className="py-0" width={"13%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(saleByHour)}
                  </div>
                </td>
                <td className="py-0" width={"13%"}>
                  <div readOnly className="form-control border text-right m-1">
                    {utils.formatCurrency(totalSale)}
                  </div>
                </td>
              </tr>
            );
          })}
        <QuoteTotalOfficeSectionTotal
          quoteItemManagementRoles={quoteItemManagementRoles}
        />
      </tbody>
    </Table>
  );
};

export default QuoteTotalOfficeSection;
